import React from 'react';
import { useUpdateVideo } from '../../hooks/useAppResources';
import {
    Box,
    Typography,
    FormControl,
    Button,
    TextField
} from "@mui/material";

function VideoDescriptionManager({item, style}){
    const updateVideo = useUpdateVideo();
    const [vidDesc, setVidDesc] = React.useState(item.vidDescription);

    let newVid ={
        Id: item.id,
        VidUrl: item.vidUrl,
        VidCategory: item.vidCategory,
        VidDescription: vidDesc,
        VidOrder: item.vidOrder,
        VidName: item.vidName,
        VidRoles: item.vidRoles,
    }

    function submitNotes(){
        updateVideo.mutate(newVid);

        setVidDesc();
    };

    return(
        <Box sx={style} style={{display: 'flex', justifyContent: 'space-between', justifyContent:'center' }}>
            <Box style={{flex:1, width:'100%'}}>
            <Typography id="modal-modal-title" variant="h5" component="h2" style={{textAlign:'center'}}>
                Video Description
            </Typography>
            <div style={{display:'flex', flexDirection:'column', width:'100%',}}>
                <FormControl sx={{ m: 2 }} style={{}}>
                    <TextField multiline rows={10} value={vidDesc} onChange={(event)=>setVidDesc(event.target.value)}></TextField>
                </FormControl>
                <Button onClick={() => submitNotes()}>Update Video Description</Button>
            </div>
            </Box>
        </Box>
    )
};

export default VideoDescriptionManager;